// extracted by mini-css-extract-plugin
module.exports = {"button":"headbutton_button__wls0G","initials":"headbutton_initials__sgquK"};